import { gql } from "@/gql/__generated__";
import { useMutation } from "@apollo/client";

export const SUBSCRIPTION_OFFER_REJECT = gql(`
  mutation subscriptionOfferReject($subscriptionOfferId: ID!) {
    subscriptionOfferReject(subscriptionOfferId: $subscriptionOfferId) {
      ... on SubscriptionOffer {
        __typename
        id
      }
      ... on SubscriptionOfferNotFound {
        __typename
        id
      }
      ... on SubscriptionOfferInvalidStatus {
        __typename
        id
      }
    }
  }
`);

export function useSubscriptionOfferReject({
  subscriptionOfferId
}: {
  subscriptionOfferId: string;
}) {
  return useMutation(SUBSCRIPTION_OFFER_REJECT, {
    variables: { subscriptionOfferId }
  });
}
